import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=326bd5e1&"
import script from "./HeaderBar.ts?vue&type=script&lang=js&"
export * from "./HeaderBar.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports